// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Eléments qui permettent de déposer une candidature (au moins 1 élément requis sur 3):\n\n- URL de redirection\n- numéro de téléphone\n- email de l’entreprise\n"
export default markdown
